import { styled } from "@mui/material/styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

/**
 * The white-ink overrides are gone with the dark theme, as is the
 * `calc(100vh - 300px)` scroll box — the document scrolls normally now.
 */
export const UserInfoContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const UserInfoBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const UserInfoList = styled(List)`
  width: 100%;
  max-width: 480px;
`;

export const UserInfoListItem = styled(ListItem)`
  padding-left: 0;
  padding-right: 0;
`;

export const UserInfoIconButton = styled(IconButton)``;

export const UserInfoButtonContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
  max-width: 480px;
  margin-top: 16px;
`;

export const UserInfoButton = styled(Button)``;
